import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBox = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 105.94267 105.36421">
    <path fill={theme.palette.grey[100]} d="m52.973 0-52.973 26.302v3.5568l52.973 26.219 52.973-26.302v-3.474l-52.981-26.302z" />
    <path fill={theme.palette.primary.A100} transform="translate(0, 26.4)" d="m52.973 26.294-52.973-26.294v52.67l52.807 26.294 53.143-26.294v-52.67l-52.977 26.294z" />
    <path fill={theme.palette.primary.A400} transform="translate(0, 26.4)" d="m0 0v52.477l52.807 26.28 0.1656-0.0823v-52.56l-52.642-26.115h-0.331z" />
    <path fill={theme.palette.primary.A400} transform="translate(22, 10.3)" d="m0 5.2847 52.924 26.259 10.767-5.285-53.09-26.259-10.601 5.2844z" />
    <path fill={theme.palette.primary.A400} transform="translate(74, 36.6)" d="m0 5.3016 10.746-5.3016v16.567l-2.8933-0.497-3.0583 3.728-4.7944-0.331v-14.165" />
    <path fill={theme.palette.grey[100]} transform="translate(22, 64.5)" d="m17.276 14.839-13.06-6.6267c-0.4961-0.2485-0.9094-0.9939-0.9094-1.6567 0-0.6627 0.4133-0.994 0.9093-0.7456l13.06 6.627c0.4959 0.2487 0.9092 0.9941 0.9092 1.6569 0.0002 0.7455-0.4133 0.9939-0.9092 0.7455zm-1.653 4.142-11.407-5.715c-0.4961-0.249-0.9094-0.994-0.9094-1.657 0-0.6628 0.41326-0.9941 0.90923-0.7457l11.407 5.7157c0.496 0.2487 0.9093 0.9941 0.9093 1.6567 0 0.6628-0.4133 0.9941-0.9093 0.7457zm4.051-9.8572-17.855-8.9463c-0.9923-0.49702-1.819 0.08288-1.819 1.3255v12.011c0 1.2426 0.82644 2.6507 1.8186 3.1477l17.938 8.9463c0.992 0.497 1.8187-0.0829 1.8187-1.3255v-12.094c-0.084-1.242-0.911-2.567-1.902-3.0642z" />
  </SvgIcon>
);

IconBox.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconBox);



// WEBPACK FOOTER //
// ./src/components/icons/IconBox.js